<script setup lang="ts">
import { computed, defineAsyncComponent, ref } from 'vue'
import { usePage } from '@inertiajs/vue3'
import type { MemberWelcome } from '@/api/resources/activation/memberWelcome'

const Welcome = defineAsyncComponent(() => import('./MemberWelcome.vue'))
const page = usePage()
const dismissed = ref<string | null>(null)
const welcome = computed(() => page.props.memberWelcome as MemberWelcome | null | undefined)
const key = computed(() => {
    const user = page.props.user as { id?: number; current_organization_id?: number } | undefined
    return `${user?.id}:${user?.current_organization_id ?? welcome.value?.organization_name}`
})
const show = computed(() => welcome.value && dismissed.value !== key.value
    && !page.component?.startsWith('Activation/')
    && !(page.props.profileCompletion as { required?: boolean } | undefined)?.required
    && !page.props.microlearningBlock && !page.props.announcement && !page.props.limitedAccessKey && !page.props.isImpersonating)
</script>
<template><Welcome v-if="show && welcome" :key="key" :welcome="welcome" @close="dismissed = key" /></template>
